import { createApp } from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'

createApp(App).use(store).use(router).mount('#app')

// Google Analytics (gtag.js) — chargé dynamiquement pour rester compatible
// avec une CSP sans 'unsafe-inline' (aucun script inline dans index.html)
declare global {
  interface Window {
    dataLayer: unknown[];
  }
}
window.dataLayer = window.dataLayer || [];
function gtag(...args: unknown[]) {
  window.dataLayer.push(args);
}
gtag('js', new Date());
gtag('config', 'G-733FBSLC3N');

const gaScript = document.createElement('script');
gaScript.async = true;
gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-733FBSLC3N';
document.head.appendChild(gaScript);
